import { createFileRoute } from '@tanstack/react-router';
import { PickListWizard } from '@/features/inventory/PickListWizard';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const uuid = (value: unknown) =>
  typeof value === 'string' && UUID.test(value) ? value : undefined;

function NewPickListRoute() {
  const { jobId, from } = Route.useSearch();
  return <PickListWizard jobId={jobId} fromLocationId={from} />;
}

export const Route = createFileRoute('/_dashboard/dashboard/inventory/pick-lists_/new')({
  validateSearch: (search: Record<string, unknown>): { jobId?: string; from?: string } => ({
    jobId: uuid(search.jobId),
    from: uuid(search.from),
  }),
  component: NewPickListRoute,
});
